import React, { useState, useRef, useEffect } from 'react';

const HelpTooltip = ({ helpText }) => {
  const [isVisible, setIsVisible] = useState(false);
  const tooltipRef = useRef(null);
  const iconRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target) &&
        iconRef.current &&
        !iconRef.current.contains(event.target)
      ) {
        setIsVisible(false);
      }
    };

    if (isVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isVisible]);

  const toggleTooltip = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div className="relative inline-flex items-center ml-2">
      <button
        ref={iconRef}
        type="button"
        onClick={toggleTooltip}
        className="w-4 h-4 rounded-full bg-gray-400 hover:bg-gray-500 text-white text-[10px] flex items-center justify-center transition-colors cursor-pointer flex-shrink-0"
        aria-label="Help information"
      >
        i
      </button>

      {isVisible && (
        <div
          ref={tooltipRef}
          className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 z-50 w-max max-w-[calc(100vw-40px)]"
        >
          <div className="bg-white text-black text-sm px-4 py-3 rounded-lg shadow-lg border border-gray-200 whitespace-normal">
            {helpText}
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-white"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HelpTooltip;